export default __webpack_public_path__ + "static/media/home-photography-bg-img-01.0cab6293.jpg";